import { ConciergeFullPageSkeleton } from "@brandclub/bc-widgets";

const ConciergeFullScreenLoading = () => <ConciergeFullPageSkeleton />;

export default ConciergeFullScreenLoading;
